import React from "react";
import { Switch, FormControlLabel, ThemeProvider } from "@mui/material";
import { switchTheme } from "../../styles/switchTheme";

interface MeasurementSwitchProps {
  measurementUnit: "m²" | "sqft";
  onUnitChange: (newUnit: "m²" | "sqft") => void;
}

const MeasurementSwitch: React.FC<MeasurementSwitchProps> = ({
  measurementUnit,
  onUnitChange,
}) => {
  const handleUnitChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newUnit = event.target.checked ? "m²" : "sqft";
    onUnitChange(newUnit);
  };

  return (
    <ThemeProvider theme={switchTheme}>
      <FormControlLabel
        control={
          <Switch
            checked={measurementUnit === "m²"}
            onChange={handleUnitChange}
            name="measurementUnit"
            color="primary"
            sx={{ width: 60 }}
          />
        }
        label={measurementUnit}
      />
    </ThemeProvider>
  );
};

export default MeasurementSwitch;